var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getAccountId } from '@ally/transfer-account-utils';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { allFrequencies, DATE_PICKER_FORMAT, oneTime, SERVER_TIMEZONE, TransferDurationValues, } from '../constants';
dayjs.extend(utc);
dayjs.extend(timezone);
export var findFrequency = function (value) {
    var frequency = allFrequencies.find(function (f) { return f.value === value; });
    return frequency !== null && frequency !== void 0 ? frequency : oneTime;
};
/**
 * TransferAccount should always exist, typecast to ignore undefined
 */
var findAccount = function (account, accounts) {
    return accounts.find(function (a) { return getAccountId(a) === account; });
};
export var getDuration = function (_a) {
    var duration = _a.duration, durationAmount = _a.durationAmount, durationDate = _a.durationDate, durationQuantity = _a.durationQuantity;
    if (duration) {
        switch (duration) {
            case TransferDurationValues.AMOUNT:
                return {
                    tag: TransferDurationValues.AMOUNT,
                    amount: durationAmount || 0,
                };
            case TransferDurationValues.DATE:
                return {
                    tag: TransferDurationValues.DATE,
                    date: durationDate ? new Date(durationDate) : new Date(),
                };
            case TransferDurationValues.QUANTITY:
                return {
                    tag: TransferDurationValues.QUANTITY,
                    quantity: durationQuantity || 0,
                };
            default:
                return { tag: TransferDurationValues.MANUAL };
        }
    }
    return undefined;
};
var formValuesToTransfer = function (values, accounts, meta) {
    var amount = values.amount, deliveryDate = values.deliveryDate, frequency = values.frequency, fromAccount = values.fromAccount, toAccount = values.toAccount, duration = values.duration, durationAmount = values.durationAmount, durationDate = values.durationDate, durationQuantity = values.durationQuantity, rest = __rest(values, ["amount", "deliveryDate", "frequency", "fromAccount", "toAccount", "duration", "durationAmount", "durationDate", "durationQuantity"]);
    var transferSpeed = meta.transferSpeed, withdrawalDate = meta.withdrawalDate;
    var transfer = __assign({ amount: Number(amount), deliveryDate: dayjs.tz(deliveryDate, DATE_PICKER_FORMAT, SERVER_TIMEZONE), frequency: findFrequency(frequency), fromAccount: findAccount(fromAccount, accounts), toAccount: findAccount(toAccount, accounts), transferSpeed: transferSpeed, withdrawalDate: withdrawalDate, duration: getDuration({
            duration: duration,
            durationAmount: durationAmount,
            durationDate: durationDate,
            durationQuantity: durationQuantity,
        }) }, rest);
    return transfer;
};
export default formValuesToTransfer;
//# sourceMappingURL=formValuesToTransfer.js.map